import { render, staticRenderFns } from "./DetailReceiveForm.vue?vue&type=template&id=296cb264&scoped=true&"
import script from "./DetailReceiveForm.vue?vue&type=script&lang=js&"
export * from "./DetailReceiveForm.vue?vue&type=script&lang=js&"
import style0 from "./DetailReceiveForm.vue?vue&type=style&index=0&id=296cb264&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296cb264",
  null
  
)

export default component.exports